<template>
  <div class="shareholders-details-home">
    <RkTabs v-model="activeTab" :options="options" shrink slider />
    <keep-alive>
      <components :is="component"></components>
    </keep-alive>
  </div>
</template>

<script>
import RkTabs from '@/components/common/RkTabs.vue'
import EquityChangeDetails from '@/components/f10/shareholders/equityChangeDetails/EquityChangeDetails.vue'
import MajorShareholdersDetails from '@/components/f10/shareholders/majorShareholdersDetails/MajorShareholdersDetails.vue'
import InstitutionalShareholdingDetails from '@/components/f10/shareholders/InstitutionalShareholdingDetails.vue'
import { sendMsg } from '@/plugins/msg'
const components = {
  change: EquityChangeDetails,
  shareholders: MajorShareholdersDetails,
  institutions: InstitutionalShareholdingDetails
}
export default {
  components: { RkTabs },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    options() {
      const options = [
        {
          label: '股本变动',
          value: 'change'
        },
        {
          label: '主要股东持股',
          value: 'shareholders'
        }
      ]
      if (this.market === 'us') {
        options.push({
          label: '机构持股',
          value: 'institutions'
        })
      }
      return options
    },
    activeTab: {
      get() {
        return this.$route.query.type
      },
      set(type) {
        this.$router.replace({
          path: '/f10/shareholders',
          query: {
            symbol: this.symbol,
            type,
            replace: true
          }
        })
      }
    },
    component() {
      return components[this.activeTab]
    }
  },
  created() {
    sendMsg({ event: 'setTitle', title: '股东股本' })
  }
}
</script>
